import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { Switch, Box, Tooltip, ListItemIcon } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme } from '../redux/preferencesSlice';
export const ThemeToggle = () => {
    const dispatch = useDispatch();
    const mode = useSelector((state) => state.preferences.theme);
    const handleToggle = () => {
        dispatch(toggleTheme());
    };
    return (_jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(ListItemIcon, { children: mode === 'dark' ? _jsx(DarkModeIcon, {}) : _jsx(LightModeIcon, {}) }), _jsx(Tooltip, Object.assign({ title: mode === 'dark'
                    ? 'Switch to light mode'
                    : 'Switch to dark mode' }, { children: _jsx(Switch, { checked: mode === 'dark', onChange: handleToggle, "aria-label": mode === 'dark'
                        ? 'Switch to light mode'
                        : 'Switch to dark mode', inputProps: {
                        'aria-label': 'Toggle between light and dark mode',
                    }, "data-testid": "theme-toggle" }) }))] })));
};
